module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"connected_with":"Connecté avec {username}","logout":"Déconnexion"}}')
  delete Component.options._Ctor
}
